/* design/Components.dc.html · Sheet; motion from Main.dc.html (spring, backdrop 32% / 48%). */
.backdrop {
  position: fixed;
  inset: 0;
  background: var(--dim);
  animation: fade-in 260ms ease;
  z-index: 20;
}
.sheet:focus {
  outline: none;
}
.sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 21;
  background: var(--card);
  border-radius: 28px 28px 0 0;
  padding: 6px 16px calc(var(--safe-bottom) + 30px);
  display: flex;
  flex-direction: column;
  max-height: calc(100% - var(--safe-top) - 10px);
  overflow-y: auto;
  overscroll-behavior: contain;
  animation: slide-up 420ms var(--spring-sheet);
  will-change: transform;
}
.grouped {
  background: var(--bg);
}
.full {
  top: calc(var(--safe-top) + 10px);
}
.tall {
  top: calc(var(--safe-top) + 48px);
}
.grabber {
  width: 36px;
  height: 5px;
  border-radius: var(--r-pill);
  background: var(--fill);
  align-self: center;
  flex-shrink: 0;
  margin-bottom: 4px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
}
.title {
  font-size: 17px;
  font-weight: 800;
}
.spacer {
  width: 44px;
  height: 44px;
}
.close {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--secondary);
}
.closeDot {
  width: 30px;
  height: 30px;
  border-radius: var(--r-pill);
  background: var(--fill);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Stacking: sheets 20–21 < action sheets 25–26 < full screens 30 < toasts 40. */
.actionBackdrop {
  z-index: 25;
}

/* Action sheet (design/SleepTimer.dc.html): floating card + separate "Done" button */
.action {
  position: fixed;
  left: 8px;
  right: 8px;
  bottom: calc(var(--safe-bottom) + 34px);
  z-index: 26;
  display: flex;
  flex-direction: column;
  gap: 8px;
  animation: slide-up 420ms var(--spring-sheet);
}
.actionCard {
  background: var(--card-raised);
  border-radius: 28px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.actionHead {
  padding: 18px 20px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
}
.actionOption {
  min-height: 56px;
  padding: 0 20px;
  border-top: 0.5px solid var(--separator);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 17px;
  font-weight: 500;
  color: var(--label);
  text-align: left;
}
.actionOption[aria-pressed='true'] {
  font-weight: 700;
  color: var(--accent-text);
}
.actionDone {
  height: 56px;
  border-radius: 20px;
  background: var(--card-raised);
  font-size: 17px;
  font-weight: 800;
  color: var(--accent-text);
}
